import { Drawer } from '@lounge-fe/ui-kit'
import { ShopifySectionComponent } from '@/types/ShopifySectionComponent'
import { HeaderData } from './types'
import { Basket } from '../Basket'
import { Navigation } from '@/features/navigation/components/Navigation'
import { useMemo } from 'react'
import { NavigationDrawer } from '@/features/navigation/components/NavigationDrawer'
import { HomeNavigation } from '@/features/navigation/components/NavigationDrawer/HomeNavigation'
import { SubNavigation } from '@/features/navigation/components/NavigationDrawer/SubNavigation'
import { HeaderSearch } from './HeaderSearch'

export const Header: ShopifySectionComponent<HeaderData> = ({ data }) => {
  const menuItems = useMemo(() => data?.menuItems ?? [], [data?.menuItems])

  return (
    <Navigation
      basketComponent={
        <Basket
          emptyBagAction={data?.emptyBagAction}
          choiceChipQuickAdd={data?.cartChoiceChipQuickAdd}
          cartDiscountProgress={data?.cartDiscountProgress}
          claimOfferTrigger={data?.claimOfferTrigger}
          cartDonation={data?.cartDonation}
          infoTooltip={data?.infoTooltip}
        />
      }
      searchComponent={
        <HeaderSearch
          searchTiles={data?.searchTiles}
          suggestedSearchTermFallbacks={data?.suggestedSearchTermFallbacks}
        />
      }
    >
      <NavigationDrawer.Drawer>
        {({ onOpen }) => (
          <>
            <Navigation.Header onMenuClick={onOpen} />
            <Drawer.Pagination>
              <NavigationDrawer.Content>
                <HomeNavigation
                  menuItems={menuItems}
                  drawerFooterMenu={data?.drawerFooterMenu}
                />
                <SubNavigation menuItems={menuItems} tiles={data?.tiles} />
              </NavigationDrawer.Content>
            </Drawer.Pagination>
          </>
        )}
      </NavigationDrawer.Drawer>
    </Navigation>
  )
}
